import { isPayByUser } from '../constants';

const sortDeals = (deals: any[], key: string, pinPayByUser: boolean = false) =>
  deals.slice().sort((a, b) => {
    if (pinPayByUser) {
      // when flag is eanbled, pin pay by user deal to the start of the list
      // if no pay by user, continue regular sort
      const isAPayByUser = isPayByUser(a.paymentArrangement);
      const isBPayByUser = isPayByUser(b.paymentArrangement);

      if (isAPayByUser && !isBPayByUser) return -1;
      if (!isAPayByUser && isBPayByUser) return 1;
    }

    if (a[key] > b[key]) return -1; // Return -1 to place 'a' before 'b'
    if (a[key] < b[key]) return 1; // Return 1 to place 'b' before 'a'

    return 0;
  });

export default sortDeals;
